"use strict";

var Logger = require("js-logger");

Logger.useDefaults({
	defaultLevel: Logger.ERROR
});

module.exports = {
	ApplePayHelper: require("./ApplePayHelper"),
	CartItemQuantity: require("./CartItemQuantity"),
	CartItemUseOnDay: require("./CartItemUseOnDay"),
	ChargeToday: require("./ChargeToday"),
	CheckoutActions: require("./CheckoutActions"),
	CheckoutStore: require("./CheckoutStore"),
	DonationAmount: require("./DonationAmount"),
	EventRegistrationHelper: require("../eventComponents/EventRegistrationHelper"), //Here because the EventsLayout.cshtml load it, checkoutComponents is used on less pages, but we really need to move everything to a single bundle.
	Frequency: require("./Frequency"),
	GooglePayHelper: require("./GooglePayHelper"),
	PaymentTypeSelector: require("./PaymentTypeSelector"),
	PayPalHelper: require("./PayPalHelper"),
	PledgeStatementHelper: require("../accountComponents/PledgeStatementHelper")
};
